export { CHROME_EXTENSION_ID } from 'constants/runtimeConfig';

export const WEBSITE_SENTRY_DSN =
  'https://44839bac2d7547769e214445b25f43d9@o398470.ingest.sentry.io/5257803';
